import { DataNotFound } from '../../../CommonComponents/DataNotFound';


const CulturalLandmarks = () => {

  return (
    <DataNotFound />
  );
};

export default CulturalLandmarks;
